import { Selector } from '@ngxs/store';

import { AuthState, AuthStateModel } from './auth.state';

export class AuthGetterState {
  @Selector([AuthState])
  static getToken(state: AuthStateModel) {
    return state.authorization;
  }

  @Selector([AuthState])
  static getCurrentUser(state: AuthStateModel) {
    return state.currentUser;
  }
}
